import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/analytics';
import RoutePaths from '@/router/route_paths';
import FlagIcon from '@/components/ui/FlagIcon.vue';
import App from './App.vue';
import router from './router/index';
import store from './store';
import vuetify from './plugins/vuetify';

Vue.component('flag-icon', FlagIcon);

require('./style/transitions.css');

Vue.config.productionTip = false;

Vue.prototype.$store = store;

router.beforeEach((to, from, next) => {
  store.commit('setMainLoading', true);
  if (to.path !== RoutePaths.START && to.path !== RoutePaths.LOGIN && !store.state.user) {
    router.push(RoutePaths.START);
  } else {
    next();
  }
});

const firebaseConfig = {
  apiKey: 'AIzaSyAwVdbUeAqFu0avLUh7hJFPlq9Oqcp-hdU',
  authDomain: 'bluebird-pronunciator.firebaseapp.com',
  databaseURL: 'https://bluebird-pronunciator.firebaseio.com',
  projectId: 'bluebird-pronunciator',
  storageBucket: 'bluebird-pronunciator.appspot.com',
  messagingSenderId: '255174562729',
  appId: '1:255174562729:web:ec76166a3a028129daeab8',
  measurementId: 'G-N174N2VS0N',
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
